import React, { useState, useContext, useEffect } from 'react';
import FilesContext from '../../context/FilesProvider';
import AuthContext from '../../context/AuthProvider';
// libs
import { toast } from 'react-hot-toast';
// assets
import Download from '../../assets/download.svg';
import Loader from '../../helpers/Loader';
// components
import DateRange from './DateRange';

export default function DownloadFiles() {
  // context
  const { loading, requestReports } = useContext(FilesContext);
  const { datalogin } = useContext(AuthContext);

  const [type, setType] = useState('');
  const [types, setTypes] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  // const types = [
  //   { title: 'Reportes - yummers', value: 'yummers' },
  //   { title: 'Reportes - comercios', value: 'commerces' },
  // ];

  useEffect(() => {
    if (datalogin) {
      setTypes([
        {
          title: 'Descargar todos los datos de reportes',
          value: datalogin.service === 'YUMMER' ? 'yummers' : 'commerces',
          type: 'all-data',
        },
        {
          title: 'Elegir rango de fechas de reportes',
          value: datalogin.service === 'YUMMER' ? 'yummers' : 'commerces',
          type: 'date-range',
        },
      ]);
    }
  }, [datalogin]);

  const handleChangeType = (type) => {
    console.log(
      '🚀 ~ file: DownloadFiles.jsx:41 ~ handleChangeType ~ type',
      type
    );
    // const value = e.target.value;
    setType(type);
  };

  /**
   * funcion para lanzar el toast de confirmacion de descarga
   */
  const launchToast = () => {
    toast.success('Listo! revisa tus descargas.', {
      position: 'top-center',
      duration: 5000,
    });
  };

  /**
   * funcion para descargar arcihvo
   */
  const downloadCsv = async () => {
    let res;
    if (type?.type === 'date-range') {
      res = await requestReports(type.value, dateRange);
    } else {
      res = await requestReports(type.value, null);
    }
    if (res) {
      launchToast();
    }
  };

  return (
    <>
      <div className="radios-container">
        {types.map((type, i) => {
          return (
            <label class="container-radio" key={i}>
              {type.title}
              <input
                type="radio"
                name="radio"
                value={type.value}
                onChange={() => handleChangeType(type)}
              />
              <span class="checkmark-radio"></span>
            </label>
          );
        })}
        {type?.type === 'date-range' && (
          <DateRange setDateRange={setDateRange} />
        )}
      </div>
      {loading ? (
        <div className="actions">
          <Loader />
        </div>
      ) : (
        <button
          onClick={() => downloadCsv()}
          className={type ? 'btn-yummy btn-bg' : ' btn-yummy btn-bg-disabled'}
          disabled={!type}>
          <img src={Download} className="btn-image" alt="" srcset="" />
          Descargar reporte
        </button>
      )}
    </>
  );
}
